module.exports = __webpack_public_path__ + "static/media/my_stories.c33b763e.svg";